import swaggerClient from "./../remote-client";
import Utils from "../Utils";

export default class hfOfficesServiceImpl {
  fetchHFOffices(userId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacility.getHfWithId(
            {
              id: userId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        () => {
          return Promise.reject({ type: Utils.errorTypes.UNABLE_TO_CALL_API });
        }
      )
      .then(result => {
        return result.body;
      })
      .catch(reason => {
        return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }
}
